import styled from "styled-components";

export const PrivacyPolicyWrapper = styled.div`
    padding: 200px 10px 50px 10px;
    max-width: 1240px;
    margin: 0 auto;
    width: 95%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const PrivacyPolicyHeader = styled.h1`
    text-align: center;
    font-family: "e-Ukraine", sans-serif;
    font-weight: 600;
    font-size: 28px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #01904e;

    @media(max-width: 430px){
      font-size: 20px;
    }

`

export const PrivacyPolicyContainer = styled.div`
   border-bottom: 1px solid #000;
`

export const PrivacyPolicyTitle = styled.div`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: -0.04em;
  text-transform: uppercase;
  color: #01904e; 
`
export const PrivacyPolicyText = styled.div`
    font-family: "e-Ukraine", sans-serif;
    font-weight: 300;
    font-size: 13px;
    line-height: 130%;
    letter-spacing: -0.03em;
    text-align: justify;
    color: #484848;
`